import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=11be5f6a&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=ts"
export * from "./Widget.vue?vue&type=script&lang=ts"
import style0 from "./Widget.vue?vue&type=style&index=0&id=11be5f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be5f6a",
  null
  
)

export default component.exports